import useEvent from 'react-use-event-hook'
import { SbpBank } from 'application/core/domain/useCase/sbp/useSbpBanks'
import toastNotify from 'application/presentation/context/ToastNotify'
import { addUsedBank } from 'features/SBP/bankUsed'
import { createSBPPayment } from 'application/core/domain/useCase/payments/sbpPay'

import s from './SBPBankItem.module.scss'

type Props = {
  orderId: string
  item: SbpBank
  onSelected: (item: SbpBank) => void
  onCreateSBPPaymentError: (item: SbpBank) => void
}

export const SBPBankItem = ({ orderId, item, onSelected, onCreateSBPPaymentError }: Props) => {
  const handleBankPress = useEvent(async () => {
    const [error, qr] = await createSBPPayment(orderId)
    if (error || !qr) {
      toastNotify(error ?? 'Произошла ошибка при совершении оплаты')

      return onCreateSBPPaymentError(item)
    }

    const deepLink = item.url.replaceAll('{QRC_ID}', qr.qrId).replaceAll('{QUERY_STRING}', '')
    try {
      window.open(deepLink, '_blank')?.focus()

      addUsedBank(item.name)
      onSelected(item)
    } catch (e) {
      toastNotify('Приложение банка не найденно, выберите другой банк')
    }
  })

  return (
    <button className={s.button} type="button" onClick={handleBankPress}>
      <img className={s.icon} src={item.logo} width={24} height={24} alt={item.name} />
      {item.name}
    </button>
  )
}
